import React from 'react';
import ShowcaseSuggestions from './showcase-suggestions';

function MobileSuggestions() {
  return (
    <div>
      <ShowcaseSuggestions />
    </div>
  );
}

export default MobileSuggestions;
